import appConfiguration from "@/components/cfg/AppCfg";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface BrandLogoProps {
  showTitle?: boolean;
  className?: string;
  asLink?: boolean;
}

export const BrandLogo = ({
  showTitle = true,
  className,
  asLink = true,
}: BrandLogoProps) => {
  const hasSubtitle = appConfiguration.documentEnv !== undefined;

  const content = (
    <div className={cn("@container w-full h-full flex items-center gap-2")}>
      {/* Logo SVG */}
      <svg
        viewBox="0 0 64 64"
        className="h-full shrink-0"
        preserveAspectRatio="xMinYMid meet"
      >
        <rect x="0" y="0" width="64" height="64" />
        <g className="fill-white">
          <path d="M6.235,18.459l0,27.082l4.922,0l0,-19.003l0.067,0l5.859,19.003l4.051,0l5.859,-19.193l0.067,0l0,19.193l4.922,0l0,-27.082l-7.4,0l-5.29,18.624l-0.067,0l-5.592,-18.624l-7.4,0Z" />
          <path d="M41.86,40.534l0,-17.069l3.75,0c1.295,0 2.383,0.209 3.265,0.626c0.882,0.417 1.59,1.018 2.126,1.802c0.536,0.784 0.921,1.726 1.155,2.826c0.234,1.1 0.352,2.333 0.352,3.698c0,1.492 -0.167,2.756 -0.502,3.793c-0.335,1.037 -0.781,1.878 -1.339,2.522c-0.558,0.645 -1.194,1.106 -1.908,1.384c-0.714,0.278 -1.45,0.417 -2.21,0.417l-4.687,0Zm-5.257,-22.075l0,27.082l10.312,0c1.831,0 3.421,-0.347 4.771,-1.043c1.351,-0.696 2.478,-1.65 3.382,-2.864c0.904,-1.214 1.58,-2.655 2.026,-4.324c0.447,-1.669 0.67,-3.49 0.67,-5.462c0,-2.251 -0.273,-4.21 -0.82,-5.879c-0.546,-1.669 -1.306,-3.059 -2.277,-4.172c-0.971,-1.113 -2.12,-1.947 -3.449,-2.503c-1.328,-0.556 -2.762,-0.834 -4.302,-0.834l-10.312,0Z" />
        </g>
      </svg>

      {/* Text content */}
      {showTitle && (
        <div className="hidden @[140px]:flex flex-col gap-1">
          <h1 className="text-xl leading-none font-semibold text-black">
            {appConfiguration.documentTitle}
          </h1>
          {hasSubtitle && (
            <p className="text-sm leading-none font-normal text-black">
              {appConfiguration.documentEnv}
            </p>
          )}
        </div>
      )}
    </div>
  );

  if (asLink) {
    return (
      <Link to="/" className={cn("flex p-0 m-0", className)}>
        {content}
      </Link>
    );
  }

  return <span className={cn("flex p-0 m-0", className)}> {content}</span>;
};
